import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { LensToday } from './lenses/L01-Today';
import { LensFinancial } from './lenses/L02-Financial';
import { LensSales } from './lenses/L03-Sales';
import { LensInventory } from './lenses/L04-Inventory';
import { LensReceivables } from './lenses/L05-Receivables';
import './styles.css';

function Shell() {
  return (
    <div className="app">
      <aside className="nav">
        <h1>GCSD Hub</h1>
        <p className="phase">Phase 1 · read-only</p>
        <nav>
          <NavLink to="/">L01 — اليوم</NavLink>
          <NavLink to="/L02">L02 — المالية</NavLink>
          <NavLink to="/L03">L03 — المبيعات</NavLink>
          <NavLink to="/L04">L04 — المخزون</NavLink>
          <NavLink to="/L05">L05 — التحصيل</NavLink>
        </nav>
      </aside>
      <main>
        <Routes>
          <Route path="/" element={<LensToday />} />
          <Route path="/L02" element={<LensFinancial />} />
          <Route path="/L03" element={<LensSales />} />
          <Route path="/L04" element={<LensInventory />} />
          <Route path="/L05" element={<LensReceivables />} />
        </Routes>
      </main>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  </React.StrictMode>,
);
